import styled from '@emotion/styled';
import { fonts } from '../../global';

export const MobileMenuClosedButton = styled.button`
    border: none;
    background-color: transparent;
    cursor: pointer;
    color: inherit;
    font-family: ${fonts.roboto};
    font-weight: bold;
    font-size: 18px;
    z-index: 10;
`;
